export default __webpack_public_path__ + "5cc642fb7ce554291deff001e82320de.woff";